<script>
    import { onMount } from 'svelte';

    function scrollToSection(id) {
        return function () {
            const section = document.getElementById(id);
            console.log(section);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };
    }

    onMount(() => {
        // Any initialization code here
    });
</script>

<nav>
    <input type="checkbox" id="check">
    <label for="check" class="checkbtn">
        <i class="fas fa-bars"></i>
    </label>
    <a id="home-button" href="./index.html">
        <div id="nav-bar-title">
            <img id="logo" src='./assets/logo.png' alt=" ">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="logo-text">Frederik Behrens</label>
        </div>
    </a>
    <ul>
        <li><a href="#about" on:click={scrollToSection('about')} class="blue">About me</a></li>
        <li><a href="#projects" on:click={scrollToSection('projects')} class="cyan">Projects</a></li>
        <li><a href="#skills" on:click={scrollToSection('skills')} class="red">Skills</a></li>
        <li style="margin-right: 24px;"><a href="#contact" on:click={scrollToSection('contact')} class="green">Contact</a></li>
    
    </ul>
</nav>

<style>
	:global(body) {
		margin: 0px;
		padding: 0px;
	}

	:root {
        --nav-bar-color: #fff;
        --font-inactive-color: rgba(0, 0, 0, 0.7);
        --font-active-color: rgba(12, 15, 70, 1);
        --button-color: rgba(39, 97, 255, 0.17);
        --background-color: rgb(8, 8, 8);
    }

    * {
        text-decoration: none;
        list-style: none;
        box-sizing: border-box;
    }

    nav {
        position: relative;
        width: 100%;
        background-color: var(--nav-bar-color);
        height: 80px;
        border-bottom: 4px solid rgba(0, 0, 0, 1);
    }

    #logo {
        height: 40px;
        width: 40px;
        margin-left: 24px;
        margin-right: 12px;
    }

    #nav-bar-title {
        display: inline-flex;
        justify-content: start;
        align-items: center;
        font-weight: 400;
        font-size: 20px;
    }

    #home-button{
        background-color: transparent !important;
    }

    .logo-text {
        line-height: 80px;
        font-weight: 500;
        color: transparent;
        font-size: 14px;
    }

    nav ul {
        float: right;
        padding-right: 24px;
        margin-right: 20px;
        padding: 0;
        margin: 0;
    }

    nav ul li {
        display: inline-block;
        line-height: 80px;
        margin: 0 5px;
    }

    nav ul li a {
        text-decoration: none;
        color: var(--font-inactive-color);
        font-size: 17px;
        padding: 7px 13px;
        line-height: 19px;
        border-radius: 8px;
        text-transform: capitalize;
    }

    a.active, a:hover {
        border: 3px solid rgba(0, 0, 0, 0.9);
        transition: .2s ease;
        color: var(--font-active-color);
        scale: 1.3;
    }
    .blue:hover {
        background: rgba(39, 97, 255, 0.2);
    }
    .cyan:hover {
        background: rgba(39, 255, 230, 0.5);
    }
    .red:hover {
        background: rgba(255, 97, 20, 0.5);
    }
    .green:hover {
        background: rgba(200, 255, 120, 0.5);
    }

    .checkbtn {
        font-size: 30px;
        color: rgba(0, 0, 0, 0.54);
        float: right;
        line-height: 80px;
        margin-right: 40px; 
        cursor: pointer;
        display: none;
    }
    #check {
        display: none;
    }
    @media (max-width: 952px) {
        label.logo {
            font-size: 30px;
            padding-left: 50px;
        }
        nav ul li a {
            font-size: 16px;
        }
    }
    @media (max-width: 858px) {
        .checkbtn {
            display: block;
        }
        nav {
            padding-right: 0;
            position: sticky;
        }
        ul {
            position: fixed;
            top: 0;
            width: 100%;
            height: 100vh;
            background: var(--nav-bar-color);
            top: 80px;
            left: -100%;
            text-align: center;
            transition: all .5s;
        }
        nav ul li {
            display: block;
            margin: 50px 0;
            line-height: 30px;
        }
        nav ul li a {
            font-size: 20px;
        }
        a:hover,a.active {
            background: none;
            color: var(--font-active-color );
        }
        #check:checked ~ ul {
            left: 0;
        }
    }
</style>
